import { stringify } from 'query-string';
import { entityTypeToApiType } from '../helpers/mapEntityTypes';
import { TopicFilterNames } from 'components/TopicFilters/shared';
import { EntityTypes } from 'context/entityContext';
import getCountryIds from 'helpers/getCountryIds';

// Returns an API URL to get album equivalents KPI data.
export default getEquivalentsKPIURL;

interface IEquivalentsKPIURLArgs {
  entityType: EntityTypes;
  entityIds: string[];
  countryIds?: string[];
  customerFilter?: TopicFilterNames[];
  download?: boolean;
  region?: string;
  customRegion?: string | string[];
}

function getEquivalentsKPIURL(args: IEquivalentsKPIURLArgs): string {
  const {
    entityType,
    entityIds,
    countryIds,
    customerFilter,
    download,
    region,
    customRegion,
  } = args;

  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    customerFilter,
    download,
    regionBreakdown: region && !countryIds && !customRegion ? 'region' : 'none',
  });

  return `/api/equivalents/kpi/${entityTypeToApiType(entityType)}/${entityIds}${
    params !== '' ? `?${params}` : ''
  }`;
}
